import React from "react";
import './_Spinner.css'

const Spinner = () => {
  return (
    <div className="snippet">
      <div className="spinner-circle">     
      </div>
    </div>
  );
};

export default Spinner;
